import OrganizationGroupApi from '../api/OrganizationGroupApi';
import {LearnerGroupPayload} from '../models/Groups/LearnerGroup';

class OrganizationGroupRepository {
  private organizationGroupApi = new OrganizationGroupApi();

  public async getGroups(organizationId: string) {
    return this.organizationGroupApi.getGroups(organizationId);
  }

  public async getGroupMembers(organizationId: string, groupId: string) {
    return this.organizationGroupApi.getGroupMembers(organizationId, groupId);
  }

  public async createGroup(
    organizationId: string,
    payload: LearnerGroupPayload,
  ) {
    return this.organizationGroupApi.createGroup(organizationId, payload);
  }

  public async editGroup(
    organizationId: string,
    groupId: string,
    payload: LearnerGroupPayload,
  ) {
    return this.organizationGroupApi.editGroup(
      organizationId,
      groupId,
      payload,
    );
  }

  public async deleteGroup(organizationId: string, groupId: string) {
    return this.organizationGroupApi.deleteGroup(organizationId, groupId);
  }

  public async addLearners(
    organizationId: string,
    groupId: string,
    learnerIds: string[],
  ) {
    return this.organizationGroupApi.addLearners(
      organizationId,
      groupId,
      learnerIds,
    );
  }

  public async removeLearners(
    organizationId: string,
    groupId: string,
    learnerIds: string[],
  ) {
    return this.organizationGroupApi.removeLearners(
      organizationId,
      groupId,
      learnerIds,
    );
  }

  public async enrollGroup(
    organizationId: string,
    groupId: string,
    publishedCourseId: string,
    dueDate?: Date,
  ) {
    return this.organizationGroupApi.enrollGroup(
      organizationId,
      groupId,
      publishedCourseId,
      dueDate,
    );
  }
}

export default OrganizationGroupRepository;
